module.exports = __webpack_public_path__ + "img/Team.94be55af.svg";